import React, { useState } from "react";
import { FaEllipsisV, FaCheck } from "react-icons/fa";
import { useManyways } from "../../context/ManywaysContext";
import Comments from "../Comments/Comments";
import footerStyles from "./mw-footer.scss";
import { HiUpload } from "react-icons/hi";
import { LANGUAGE_BY_LOCALE } from "../../lib/labels/locales";

const stylesToString = `${footerStyles}`;

const ManywaysFooter = () => {
  const {
    classNamePrefix,
    shareJourney,
    labels,
    locale,
    isStaging,
    restart,
    treeConfig,
    responseId,
  } = useManyways();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isLanguagePopoverOpen, setIsLanguagePopoverOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleGoToManyways = () => {
    window.open("https://manyways.io", "_blank");
    window.umami.track("Go to Manyways");
  };

  const togglePopover = () => {
    setIsLanguagePopoverOpen(false);
    setIsPopoverOpen(!isPopoverOpen);
  };

  const toggleLanguagePopover = () => {
    setIsPopoverOpen(false);
    setIsLanguagePopoverOpen(!isLanguagePopoverOpen);
  };

  const changeLanguage = (newLocale) => {
    setIsLanguagePopoverOpen(false);

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("locale", newLocale);
    window.location.href = currentUrl.toString();
  };

  const copyLink = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("continue", responseId);
    const newUrl = currentUrl.toString();

    navigator.clipboard
      .writeText(newUrl)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 3000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div>
      <style dangerouslySetInnerHTML={{ __html: stylesToString }}></style>
      <div className={`${classNamePrefix}-footer-menu`}>
        {isStaging && <Comments />}

        {treeConfig?.run_mode?.locales?.length > 0 && (
          <button
            onClick={toggleLanguagePopover}
            className="language-switcher"
            title={labels?.language}
          >
            {locale}
          </button>
        )}

        <button
          onClick={handleGoToManyways}
          className="manyways-logo"
          title={labels?.poweredBy}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.78942 4.14375H2.21045V4.2C1.57892 4.20006 1.34209 5.10003 1.10526 6C0.868416 6.9 0.631575 7.8 0 7.8H1.57894C2.21053 7.8 2.44737 6.9 2.68421 6C2.76132 5.70698 2.83843 5.41396 2.92917 5.152C2.99777 5.41385 3.04983 5.70985 3.10244 6.00972L3.10327 6.01444C3.1816 6.46092 3.26138 6.91569 3.40184 7.25881C3.54268 7.60285 3.75413 7.85625 4.10521 7.85625H5.68415V7.8H5.68421C6.31579 7.8 6.55263 6.9 6.78947 6C6.86658 5.70699 6.94369 5.41397 7.03442 5.15202C7.10302 5.41386 7.15508 5.70986 7.20768 6.00972L7.20851 6.01443C7.28684 6.46091 7.36662 6.91569 7.50708 7.25881C7.64792 7.60285 7.85936 7.85625 8.21045 7.85625H9.78942V7.8H9.78949C10.4211 7.8 10.6579 6.9 10.8947 6C11.1316 5.1 11.3684 4.2 12 4.2H10.4211C9.78949 4.2 9.55265 5.09999 9.31581 5.99998C9.23867 6.29308 9.16154 6.58618 9.07077 6.8482C9.00214 6.58631 8.95007 6.29023 8.89745 5.99028L8.89662 5.98559C8.81829 5.5391 8.73851 5.08431 8.59805 4.74119C8.45721 4.39715 8.24576 4.14375 7.89466 4.14375H6.31572V4.2C5.6842 4.20006 5.44736 5.10003 5.21053 6C5.1334 6.29309 5.05627 6.58618 4.96551 6.84819C4.89688 6.5863 4.84481 6.29022 4.79219 5.99028L4.79137 5.98558C4.71304 5.53909 4.63325 5.08431 4.49279 4.74119C4.35196 4.39715 4.14051 4.14375 3.78942 4.14375ZM4.89919 7.02709C4.80662 6.72356 4.74396 6.36642 4.68221 6.01443L4.68221 6.01442L4.68138 6.00972C4.60208 5.55771 4.52404 5.11448 4.38868 4.78381C4.2532 4.45285 4.06991 4.25625 3.78942 4.25625H3.53367C3.29816 4.36727 3.13076 4.63355 2.99548 4.97308C3.08804 5.27658 3.15068 5.63367 3.21243 5.9856L3.21325 5.99028C3.29255 6.44229 3.37059 6.88552 3.50596 7.21619C3.64144 7.54715 3.82472 7.74375 4.10521 7.74375H4.3611C4.59655 7.63274 4.76393 7.36654 4.89919 7.02709ZM7.10074 4.97309C7.23601 4.63355 7.40341 4.36728 7.63891 4.25625H7.89466C8.17516 4.25625 8.35845 4.45285 8.49393 4.78381C8.6293 5.11448 8.70734 5.55771 8.78664 6.00972L8.78747 6.01443C8.84922 6.36642 8.91187 6.72357 9.00445 7.0271C8.86919 7.36654 8.7018 7.63274 8.46634 7.74375H8.21045C7.92996 7.74375 7.74667 7.54715 7.6112 7.21619C7.47583 6.88552 7.39779 6.44229 7.31849 5.99028L7.31767 5.98559C7.25593 5.63366 7.19328 5.27658 7.10074 4.97309Z"
              fill="currentColor"
            />
          </svg>
        </button>
        <button onClick={shareJourney} title={labels?.share}>
          <HiUpload />
        </button>
        <button onClick={togglePopover} title={"show more"}>
          <FaEllipsisV />
        </button>

        {isPopoverOpen && (
          <div className={`mw-footer-popover`}>
            <button onClick={restart}>Restart</button>
            {isStaging && responseId && (
              <button onClick={copyLink}>
                {labels?.copy}{" "}
                {isCopied && (
                  <FaCheck
                    className="check"
                    style={{ marginLeft: "5px", color: "green" }}
                  />
                )}
              </button>
            )}
            <button onClick={shareJourney}>{labels?.share}</button>
          </div>
        )}

        {isLanguagePopoverOpen && (
          <div className={`mw-language-switcher-popover `}>
            {treeConfig?.run_mode?.locales.map((lang, idx) => (
              <button key={idx} onClick={() => changeLanguage(lang)}>
                {LANGUAGE_BY_LOCALE[lang]}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManywaysFooter;
